import http from "./http";

export const sendMessage = (body) => {
  return http.post("api/sendMessage", body).then((res) => res);
};

// export const joinUs = (body) => {
//   return http.post('api/v1/users/register/form', body).then(res => res);
// };
